import { css } from '@emotion/react';
import { ReactNode } from 'react';

export const Pane = (params: { children: ReactNode }) => {
	const { children } = params;

	return (
		<div
			css={css`
				width: 100%;
			`}
			{...params}
		>
			{children}
		</div>
	);
};
